<h2 id="activity-heading" class="ao-heading-300 ao-bold">Activity</h2>

<div class="ao-list activity-min-height">
	<ol
		id="activity-statuses-container"
		[@expandList]="totalVisibleActivityStatuses"
		[@expandHeight]="{
			value: totalVisibleActivityStatuses,
			params: {
				containerHeight: getListContainerHeight(),
				heightSpeed: calculateHeightAnimationSpeed(totalVisibleActivityStatuses)
			}
		}"
		aria-labelledby="activity-heading"
		aria-live="polite"
	>
		@for (
			activityStatus of claim.activityStatuses | slice: 0 : maxStatusesShowing();
			track activityStatus.date;
			let i = $index
		) {
			<li id="status{{ i }}">
				<claim-tracker-activity-status [activityStatus]="activityStatus"> </claim-tracker-activity-status>
			</li>
		} @empty {
			<li id="status-empty" class="ao-list-item ao-align-center ao-italic ao-charcoal">
				No recent activity for this claim.
			</li>
		}
	</ol>
</div>
@if (showMoreInd()) {
	<div
		[@expandCollapse]="{
			value: true,
			params: { delayEnter: calculateHeightAnimationSpeed(totalVisibleActivityStatuses), delayLeave: 0 }
		}"
	>
		<button class="ao-button-borderless ao-width-auto" (click)="showMoreActivity()">Show More</button>
	</div>
}
